// extrato-operacoes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} resgates de produto sem preço de parceiro cadastrado não entram no custo.": "%{arg1} canjes de producto sin precio de socio registrado no entran en el costo.",
    "(=) Resultado depois do programa": "(=) Resultado después del programa",
    "(=) Valor pago pelos clientes": "(=) Valor pagado por los clientes",
    "(−) Cashback gerado nos abastecimentos": "(−) Cashback generado en las cargas",
    "(−) Descontos concedidos": "(−) Descuentos otorgados",
    "(−) Resgates em dinheiro": "(−) Canjes en dinero",
    "Abastecimentos, vendas no PDV e resgates do período, com o resumo em formato de DRE: vendas, descontos, cashback, resgates e resultado.": "Cargas de combustible, ventas en el PDV y canjes del período, con el resumen en formato de estado de resultados: ventas, descuentos, cashback, canjes y resultado.",
    "Aguardando uso": "Pendiente de uso",
    "Cashback %{arg1} · Produtos %{arg2}": "Cashback %{arg1} · Productos %{arg2}",
    "Cashback gerado": "Cashback generado",
    "Combustível / produto": "Combustible / producto",
    "Custo do programa": "Costo del programa",
    "Descontos + cashback gerado + resgates em dinheiro, sobre as vendas brutas": "Descuentos + cashback generado + canjes en dinero, sobre las ventas brutas",
    "Extrato de operações": "Extracto de operaciones",
    "Operações": "Operaciones",
    "PDV (integração)": "PDV (integración)",
    "Pontos gerados": "Puntos generados",
    "Pontos usados": "Puntos usados",
    "Resgate de cashback": "Canje de cashback",
    "Resgate de produto": "Canje de producto",
    "Resgates de cashback": "Canjes de cashback",
    "Resgates de produto": "Canjes de producto",
    "Resumo do período": "Resumen del período",
    "Situação do cupom": "Situación del cupón",
    "Tipo de operação": "Tipo de operación",
    "Tipos": "Tipos",
    "Usado": "Usado",
    "Valor bruto": "Valor bruto",
    "Valor do resgate": "Valor del canje",
    "Valor líquido": "Valor neto",
    "Veja como cada valor do extrato é calculado: vendas, descontos, cashback, resgates e o resultado do período.": "Vea cómo se calcula cada valor del extracto: ventas, descuentos, cashback, canjes y el resultado del período.",
    "Vencido": "Vencido",
    "Venda no PDV": "Venta en el PDV",
    "Vendas brutas (abastecimentos e PDV)": "Ventas brutas (cargas y PDV)",
    "Vendas no PDV": "Ventas en el PDV",
};

export default catalogo;
